/**
 * L'état d'interface des paramètres du tuteur : ses trois pages sur l'état commun
 * (`ui/hooks/settingsUiState`, le même que l'élève). Une page n'a de brouillon qu'à partir de la
 * première modification, et un enregistrement réussi l'efface.
 */
import { type ApiNotificationSettings } from "../../../../adapters/student/Account/studentSettingsAdapter"
import { type TutorSettingsSection } from "../../../../adapters/tutor/Account/tutorSettingsAdapter"
import {
    initialSettingsUiState,
    settingsUiReducer,
    type SettingsUiAction,
    type SettingsUiState,
} from "../../../hooks/settingsUiState"
import { type UIStudentAddressSettings } from "../../../types/studentAccount"
import { type UITutorGeneralSettings } from "../../../types/tutorCompte"

export type TutorSettingsDrafts = {
    general: UITutorGeneralSettings | null
    address: UIStudentAddressSettings | null
    preferences: ApiNotificationSettings | null
}

export type TutorSettingsUiState = SettingsUiState<TutorSettingsSection, TutorSettingsDrafts>
export type TutorSettingsUiAction = SettingsUiAction<TutorSettingsSection>

const EMPTY_DRAFTS: TutorSettingsDrafts = { general: null, address: null, preferences: null }

/**
 * `settings` reçoit l'index d'un onglet de l'ancien écran tuteur (Général, Adresse, Profil, Réglages) :
 * 1 ouvre Adresse, 3 Réglages ; 0 (l'onglet par défaut) et 2 (Profil, devenu un parcours) la liste.
 */
const VIEW_BY_TAB: Record<number, TutorSettingsSection> = { 1: "address", 3: "preferences" }

export function initialTutorSettingsUiState(initialTab?: unknown): TutorSettingsUiState {
    return initialSettingsUiState(VIEW_BY_TAB, EMPTY_DRAFTS, initialTab)
}

export function tutorSettingsUiReducer(
    state: TutorSettingsUiState,
    action: TutorSettingsUiAction
): TutorSettingsUiState {
    return settingsUiReducer(state, action)
}
